import React from 'react';
export function Footer() {
  return <footer className="bg-navy-dark px-4 py-8 text-center text-white" data-id="element-107">
      <div className="mx-auto max-w-4xl" data-id="element-108">
        <p className="text-sm font-medium text-violet-light" data-id="element-109">
          © {new Date().getFullYear()} Dance Fitness Instructor Pro™ — All
          Rights Reserved.
        </p>
        <p className="mx-auto mt-4 max-w-3xl text-xs leading-relaxed text-slate-400" data-id="element-110">
          The content on this page is for educational and informational purposes
          only and does not replace professional fitness certification or
          medical advice. Always consult a qualified health professional before
          beginning intensive physical exercise and follow appropriate safety
          guidelines when teaching groups with special physical needs.
        </p>
        <p className="mt-4 text-xs text-slate-400" data-id="element-111">
          Terms & Conditions · Privacy Policy · Contact
        </p>
      </div>
    </footer>;
}